import React from 'react';
import './styles.css';

interface CheckboxIconConfig {
    icon: string;
    className?: string;
    style?: any;
}
export interface CheckboxProps {
    /* Controls if checkbox is filled */
    isChecked: boolean;
    /** Custom Change Handler is passed shouldBeChecked */
    onChange: any;
    /** Label for the CheckBox */
    label?: string;
    id?: string;
    className?: string;
    /**  Custom icon to use for when isChecked=true */
    isCheckedIcon?: string | CheckboxIconConfig;
    /**  Custom icon to use for when isChecked=false */
    notCheckedIcon?: string | CheckboxIconConfig;
    /**  Controls disabled status of checkbox */
    isDisabled?: boolean;
    name?: string;
}

const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps) => {
    const { isChecked, label, id, className, onChange, isCheckedIcon, notCheckedIcon } = props;
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if(props.isDisabled) return;
        else if(props.name) {
            onChange(props.name, !isChecked);
            return;
        }
        onChange(!isChecked);
    }
    //@ts-ignore
    const isCheckedIconName: string = typeof isCheckedIcon === "string" ? isCheckedIcon : isCheckedIcon?.icon;
    //@ts-ignore
    const notCheckedIconName: string = typeof notCheckedIcon === "string" ? notCheckedIcon : notCheckedIcon?.icon;
    return (
        <span onClick={handleClick} className={`action-text checkbox ${className}`} id={id}>
            <i 
                style={isChecked
                    ? typeof isCheckedIcon === "string" ? {} : isCheckedIcon?.style || {}
                    : typeof notCheckedIcon === "string" ? {} : notCheckedIcon?.style || {}
                }
                className={`material-icons ${isChecked
                    ? typeof isCheckedIcon === "string" ? "" : isCheckedIcon?.className || ""
                    : typeof notCheckedIcon === "string" ? "" : notCheckedIcon?.className || ""}
                `}
            >
                {isChecked ? isCheckedIconName : notCheckedIconName}</i>
            <span>{label}</span>
        </span>
    );
}

Checkbox.defaultProps = {
    label: "",
    isChecked: false,
    id: "",
    className: "",
    isCheckedIcon: "check_box",
    notCheckedIcon: "check_box_outline_blank"
}

export default Checkbox;